<template>
  <div class="loginWapper animatebg">
    <div class="animatebg-bg">
      <div class="animatebg-bg-circles">
        <div class="animatebg-bg-circles-circle1"></div>
        <div class="animatebg-bg-circles-circle2"></div>
        <div class="animatebg-bg-circles-circle3"></div>
        <div class="animatebg-bg-circles-circle4"></div>
        <div class="animatebg-bg-circles-circle5"></div>
        <div class="animatebg-bg-circles-circle6"></div>
      </div>
      <div class="animatebg-bg-mask"
        style="background:rgba(255, 255, 255, .52);"></div>
    </div>
    <div class="loginContent">
      <h1 class="loginTxt">登录仟抖助手</h1>
      <a-tabs default-active-key="1" @change="changeTab">
        <a-tab-pane
          key="1"
          tab="二维码登录"
          class="loginTabItem"
          style="height: 304px"
        >
          <div class="qrcode-container">
            <div class="corners"></div>
            <div class="corners"></div>
            <div class="corners"></div>
            <div class="corners"></div>
            <a-spin size="large" class="qrCodeLoadding" v-if="loading" />
            <img class="qrcodeImg" :src="qrCodeUrl" alt="" v-if="qrCodeUrl&&scanflag" /> 
            <div class="scan_line" v-if="scanflag" ></div>
            <div class="codeexpire" v-if="!scanflag" >
                        <div class="expiretips">二维码已失效<br>请刷新后重试</div>
                        <a href="javascript:void(0);" class="wxloginbtn" id="refresh" @click="refresh">刷新</a> 
                    </div>
          </div>
          <div class="tips">请使用微信<img src="@images/wechat.png" class="wechat"/>扫码</div>
          <div>关注【仟抖助手】公众号后完成登录/注册</div>
        </a-tab-pane>
        <a-tab-pane
          key="2"
          tab="账号密码登录"
          force-render
          class="account-container"
        >
          <a-form-model
            :model="form"
            class="accountLoginWapper"
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            :rules="rules"
            ref="loginForm"
          >
            <a-form-model-item prop="account">
              <a-input v-model="form.account" placeholder="请输入账号">
                <a-icon
                  slot="prefix"
                  type="user"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
              </a-input>
            </a-form-model-item>
            <a-form-model-item prop="password">
              <a-input-password
                v-model="form.password"
                type="password"
                placeholder="请输入密码"
              >
                <a-icon
                  slot="prefix"
                  type="lock"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
              </a-input-password>
            </a-form-model-item>
            <a-form-model-item>
              <a-button
                type="primary"
                @click="login"
                size="large"
                style="width: 100%"
              >
                登录
              </a-button>
            </a-form-model-item>
          </a-form-model>
        </a-tab-pane>
      </a-tabs>
    </div>

    <p style="text-align: center;position: fixed;bottom: 10px;">Copyright  2021-当前 厦门村上网络科技有限公司 All Rights Reserved.

<a href="https://beian.miit.gov.cn" target="_blank">闽ICP备2021015116号-2</a>

</p>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { qcApi, requestHttp } from '@utils/index';

export default {
  name: 'Home',
  data() {
    return {
      scanflag:true,
      loading: true,
      qrCodeUrl: null,
      login_uid: null,
      loginTimer: null,
      form: {
        account: '',
        password: '',
      },
      labelCol: { span: 0 },
      wrapperCol: { span: 24 },
      rules: {
        account: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
      },
    };
  },
  components: {},
  async mounted() {
    console.log('检测到的token',localStorage.getItem('token'))
    if(localStorage.getItem('token')){
      this.$router.replace('/dashboard');
    }
    await this.getQrCode();
    this.pollLoginStatus();
  },

  methods: {
    ...mapActions('User', ['userLogin', 'getUserRouter']), //第一个参数是store的模块名称
    async refresh(){
      this.scanflag = true;
      await this.getQrCode();
      this.pollLoginStatus();
    },
    //获取登录二维码
    async getQrCode() {
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.GET_QR_CODE}`,
        method: 'POST',
      });
      this.loading = false;
      if (code != 0) {
        this.$message.error(msg);
        return;
      }
      console.log(data);

      if (!data) return;
      const { imgurl, login_uid } = data;
      this.qrCodeUrl = imgurl;
      this.login_uid = login_uid;
    },

    //轮询获取登录状态
    pollLoginStatus() {
      this.loginTimer = setInterval(async () => {
        await this.getLoginStatus();
      }, 2000);
    },

    async getLoginStatus() {
      const { code, msg = '获取登录状态失败', data } = await requestHttp({
        api: `${qcApi.GET_LOGIN_STATUS}?login_uid=${this.login_uid}`,
        method: 'POST',
        params: {},
      });
      if (code != 0) {
        this.scanflag = false;
        clearInterval(this.loginTimer);
        this.$message.error(msg);
        // location.reload();
        return;
      } else {
        if (data.status == 2) {
          this.loginTimer && clearTimeout(this.loginTimer);
          this.loginSuccess(data);
        }
      }
    },

    //切换tab
    changeTab(key) {
      console.log(key);
      if (key == 2) {
        console.log('清空标识');
        this.loginTimer && clearInterval(this.loginTimer);
      } else {
        this.pollLoginStatus();
      }
    },
    async login() {
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          const { code, msg, data } = await requestHttp({
            api: `${qcApi.LOGIN_ACTION}`,
            method: 'POST',
            params: {
              account: this.form.account,
              password: this.form.password,
            },
          });
          if (code != 1) {
            this.$message.error(msg);
            return;
          }
          this.loginSuccess(data);
        } else {
          return false;
        }
      });
    },

    loginSuccess(data) {
      const { token } = data;
      this.$store.commit('User/SET_LOGIN', true);
      this.$store.commit('User/SET_TOKEN', token);
      this.$store.commit('User/SET_USER_INFO', data);
      this.$router.replace('/dashboard');
    },

    //根据用户，获取动态路由
    // async getUserMenu() {
    //   const { code, msg } = await this.getUserRouter();
    //   if (code == 0) {
    //     this.$router.replace('/');
    //   } else {
    //     this.$message.error(msg);
    //   }
    // },
  },

  destroyed() {
    this.loginTimer && clearInterval(this.loginTimer);
  },
};
</script>
<style lang="less" scoped>
.scan-login-bg {
  width: 200px;
  height: 200px;
  position: absolute;
  left: 0;
}
.wechat{
  width: 20px;
  margin-left: 2px;
  margin-right: 2px;
  // height: 20px;
}
.scan_line {
  height: 3px;
  width: 100%;
  background-image: linear-gradient(90deg,#fff,#ff7800 30%,#345dfe 70%,#fff);
  position: absolute;
  top: 0;
  z-index: 2;
  animation: wx-scanning 5s linear infinite;
  display: block;
}
@keyframes wx-scanning {
 0% {
  top:0
 }
 to {
  top:190px
 }
}

.codeexpire{
position: absolute;
left: 0;
top: 0;
height: 100%;
width: 100%;
display: flex;
align-items: center;
justify-content: center;
flex-direction: column; 
}
.expiretips{
	color: #262626;
	font-size: 16px;
	text-align: center;
	margin-top: 0px;
}
#refresh{
	width: 70px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  display: block; 
  background: #ff7800;
  font-size: 14px;
  color: #fff;
  border-radius: 3px;
  margin: 0 auto;
  margin-top: 5px;
}

.animatebg {
  overflow: hidden !important;
  position: relative;
  width: 100%; 
  .animatebg-bg {
    height: 100%;
    position: absolute;
    width: 100%;
    .animatebg-bg-circles {
        left: 50%;
        position: absolute;
        top: 50%;
        .animatebg-bg-circles-circle1 {
          animation: circle-move1 15s infinite;
          background: linear-gradient(180deg,#85a0ff,rgba(133,226,255,.43));
          border-radius: 17.76vw;
          height: 35.52vw;
          left: 0;
          position: absolute;
          top: 0;
          transform: translate3d(-28.33vw,-25.6vw,0);
          transform-origin: center;
          width: 35.52vw;
        }
        .animatebg-bg-circles-circle2 {
          animation: circle-move2 18s infinite;
          background: linear-gradient(180deg,#85e2ff,rgba(133,248,255,.43));
          border-radius: 19.66vw;
          height: 39.32vw;
          left: 0;
          position: absolute;
          top: 0;
          transform: translate3d(8.65vw,-17.97vw,0);
          transform-origin: center;
          width: 39.32vw;
        }
        .animatebg-bg-circles-circle3 {
          animation: circle-move3 12s infinite;
          background: linear-gradient(180deg,#85ffe9,rgba(133,218,255,.43));
          border-radius: 12.655vw;
          height: 25.31vw;
          left: 0;
          position: absolute;
          top: 0;
          transform: translate3d(-32.66vw,12.74vw,0);
          transform-origin: center;
          width: 25.31vw;
        }
        .animatebg-bg-circles-circle4 {
          animation: circle-move4 12s infinite;
          background: linear-gradient(180deg,#ff72cf,hsla(0,100%,76%,.43));
          border-radius: 13.7vw;
          height: 27.4vw;
          left: 0;
          position: absolute;
          top: 0;
          transform: translate3d(-4.74vw,-12.96vw,0);
          transform-origin: center;
          width: 27.4vw;
        }.animatebg-bg-circles-circle5 {
          animation: circle-move5 16s infinite;
          background: linear-gradient(180deg,#ff2b77,rgba(255,191,133,.43));
          border-radius: 15.21vw;
          height: 30.42vw;
          left: 0;
          position: absolute;
          top: 0;
          transform: translate3d(-56.86vw,-11.94vw,0);
          transform-origin: center;
          width: 30.42vw;
        }.animatebg-bg-circles-circle6 {
          animation: circle-move6 7s infinite;
          background: linear-gradient(180deg,#85ffe9,rgba(133,218,255,.43));
          border-radius: 12.655vw;
          height: 25.31vw;
          left: 0;
          position: absolute;
          top: 0;
          transform: translate3d(29.17vw,10.77vw,0);
          transform-origin: center;
          width: 25.31vw;
        }
    }
  }
}
.animatebg-bg-mask {
  height: 100%;
  position: absolute;
  width: 100%;
}
@keyframes circle-move1 {
 0% {
  transform:translate3d(-28.33vw,-25.6vw,0)
 }
 20% {
  transform:translate3d(-38vw,-30vw,0)
 }
 70% {
  transform:translate3d(-20vw,-36vw,0)
 }
 to {
  transform:translate3d(-28.33vw,-25.6vw,0)
 }
}
@keyframes circle-move2 {
 0% {
  transform:translate3d(8.65vw,-17.97vw,0)
 }
 40% {
  transform:translate3d(20vw,-35vw,0)
 }
 70% {
  transform:translate3d(25vw,-25vw,0)
 }
 to {
  transform:translate3d(8.65vw,-17.97vw,0)
 }
}
@keyframes circle-move3 {
 0% {
  transform:translate3d(-32.66vw,12.74vw,0)
 }
 30% {
  transform:translate3d(-35vw,5vw,0)
 }
 50% {
  transform:translate3d(-50vw,10vw,0)
 }
 to {
  transform:translate3d(-32.66vw,12.74vw,0)
 }
}
@keyframes circle-move4 {
 0% {
  transform:translate3d(-4.74vw,-12.96vw,0)
 }
 40% {
  transform:translate3d(-7vw,5vw,0)
 }
 60% {
  transform:translate3d(-3vw,-4vw,0)
 }
 to {
  transform:translate3d(-4.74vw,-12.96vw,0)
 }
}
@keyframes circle-move5 {
 0% {
  transform:translate3d(-56.86vw,-11.94vw,0)
 }
 40% {
  transform:translate3d(-36vw,-25vw,0)
 }
 60% {
  transform:translate3d(-43vw,-14vw,0)
 }
 to {
  transform:translate3d(-56.86vw,-11.94vw,0)
 }
}
@keyframes circle-move6 {
 0% {
  transform:translate3d(29.17vw,10.77vw,0)
 }
 20% {
  transform:translate3d(35vw,8vw,0)
 }
 60% {
  transform:translate3d(27vw,12vw,0)
 }
 to {
  transform:translate3d(29.17vw,10.77vw,0)
 }
}
.loginWapper {
  display: flex;
  width: 100%;
  height: 100vh;
  overflow: auto;
  background-color: #f0f2f5;
  background-image: url('~@images/login_bg.svg');
  background-repeat: no-repeat;
  background-position-x: center;
  background-position-y: 110px;
  background-size: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .loginContent {
    box-sizing: border-box;
    margin-top: 40px;
    padding: 40px;
    border-radius: 16px;
    background-color: #fff;
    box-shadow: 0 6px 12px #2123291a;
    width: 480px;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    min-height: 561px;
    z-index: 1111;
    .loginTxt {
      color: #303133;
      font-size: 30px;
      line-height: 38px; 
      width: 100%;
      margin-bottom: 20px;
      text-align:center;
    }
  }
  .loginTabItem {
    margin-top: 20px;
  }
  .ant-form {
    margin-top: 50px;
  }
  .qrcode-container {
    width: 200px;
    height: 200px;
    margin: 10px auto;
    border: 1px solid #e1e4eb;
    position: relative;
    .qrCodeLoadding {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    .qrcodeImg {
      width: 100%;
      height: auto;
    }
    .corners {
      position: absolute;
      width: 20px;
      height: 20px;
      &:nth-child(1) {
        border-top: 4px solid #ff7800;
        border-left: 4px solid #ff7800;
        top: -4px;
        left: -4px;
      }
      &:nth-child(2) {
        border-top: 4px solid #ff7800;
        border-right: 4px solid #ff7800;
        top: -4px;
        right: -4px;
      }
      &:nth-child(3) {
        border-bottom: 4px solid #ff7800;
        border-left: 4px solid #ff7800;
        bottom: -4px;
        left: -4px;
      }
      &:nth-child(4) {
        border-bottom: 4px solid #ff7800;
        border-right: 4px solid #ff7800;
        bottom: -4px;
        right: -4px;
      }
    }
  }
  .tips {
    margin-top: 30px;
    line-height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    img{
      width: 20px;
      height: 20px;
    }
  }
  .account-container {
    /deep/ .ant-input {
      border-color: #1890ff;
      height: 48px;
      line-height: 48px;
    }
  }
}
</style>
